import { useCallback } from 'react';
import { RowSelectionState, Updater } from '@tanstack/react-table';
import { isRowWithId } from '../utils';

interface UseGetSelectedRowOriginalDataProps<T> {
  data: T[];
}

export const useGetSelectedRowOriginalData = <T>({
  data,
}: UseGetSelectedRowOriginalDataProps<T>) =>
  useCallback(
    (
      updater: Updater<RowSelectionState>,
      currentState: RowSelectionState = {},
      currentSelectedRowsOriginalData: T[] = []
    ) => {
      const newSelection =
        typeof updater === 'function' ? updater(currentState) : updater;

      const selectedIds = Object.entries(newSelection)
        .filter(([_, value]) => value)
        .map(([key]) => key);

      const selectedFromCurrentData = (data || []).filter(
        (row): row is T & { id: string } =>
          isRowWithId(row) && selectedIds.includes(row.id)
      );

      const currentPageIds = new Set(
        selectedFromCurrentData.map(row => row.id)
      );

      const preservedOffPageRows = currentSelectedRowsOriginalData.filter(
        (row): row is T & { id: string } =>
          isRowWithId(row) &&
          selectedIds.includes(row.id) &&
          !currentPageIds.has(row.id)
      );

      return [...selectedFromCurrentData, ...preservedOffPageRows];
    },
    [data]
  );
